import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';

function ChangePasswordModal({show, onHide, onConfirm}) { 

  const [formSubmit, setFormSubmit] = useState(false);

  const validationSchema = Yup.object({
      oldpassword: Yup.string()
          .min(8, 'Password must be at least 8 characters')
          .max(20, 'Password must not be greater than 20 characters') 
          .required('Password is required'),
      password: Yup.string()
          .min(8, 'Password must be at least 8 characters')
          .max(20, 'Password must not be greater than 20 characters')
          .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
          .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
          .matches(/[0-9]/, 'Password must contain at least one digit')
          .matches(/[\W_]/, 'Password must contain at least one special character') 
          .required('Password is required'),
      confirmpassword: Yup.string()
          .oneOf([Yup.ref('password'), null], 'Passwords must match')
          .required('Confirm Password is required'),
  });
  

  const handleSubmit = async (values, { setSubmitting }) => {
      setFormSubmit(true);

      const params = {
        old_password: values.oldpassword,
        new_password: values.password,
        confirm_password: values.confirmpassword,
      }

      onConfirm(params);  
      setSubmitting(false);
  };

  return (
    <Modal
      show={show}
      centered
      onHide={onHide}
      dialogClassName="el-deactivate-modal"
      backdrop="static"
    >
      <Modal.Body  >
       
      <h5><b>Change Password</b></h5>

        <Formik
          initialValues={{ oldpassword: '', password: '', confirmpassword: '' }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          >
          {({ isSubmitting }) => (
              <Form className="el-login-form mt-4">
                <div className="mt-3">
                    <label htmlFor="oldpassword" className="form-label">Old Password<span className="text-red">*</span></label>
                    <Field
                    type="password"
                    name="oldpassword"
                    placeholder="Password"
                    className="form-control"
                    id="oldpassword"
                    maxLength = {20}
                    />
                    <ErrorMessage name="oldpassword" component="div" className="text-danger" />
                </div>

                <div className="mt-3">
                    <label htmlFor="password" className="form-label">Password<span className="text-red">*</span></label>
                    <Field
                    type="password"
                    name="password"
                    placeholder="Password"
                    className="form-control"
                    id="password"
                    maxLength = {20}
                    />
                    <ErrorMessage name="password" component="div" className="text-danger" />
                </div>

                <div className="mt-3">
                    <label htmlFor="confirmpassword" className="form-label">Confirm Password<span className="text-red">*</span></label>
                    <Field
                    type="password"
                    name="confirmpassword"
                    placeholder="Confirm Password"
                    className="form-control"
                    id="confirmpassword"
                    maxLength = {20}
                    />
                    <ErrorMessage name="confirmpassword" component="div" className="text-danger" />
                </div>

                <div className="d-flex mt-4">
                  <button type="submit" className="el-main-button" disabled={isSubmitting}><span>{isSubmitting ? 'Submitting...' : 'Submit'}</span></button>
                  <button type="button" className="back-link ms-3" onClick={ ()=> { onHide(); }} > Close</button>
                </div>
              </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}

export default ChangePasswordModal;